import axiosAPI from "../config/axiosInstance";
export const addNewUser = (userData) => {
  return axiosAPI("post", "user", userData);
};

export const fetchAllUsers = () => {
  return axiosAPI("get", "user");
};

export const deleteUser = (userID) => {
  return axiosAPI("delete", `user/${userID}`);
};

export const updateUser = (userID, data) => {
  return axiosAPI("patch", `user/${userID}`, data);
};

export const updateUserProfile = (data) => {
  return axiosAPI("patch", "update-profile", data);
};

export const updateUserPassword = (data) => {
  return axiosAPI("patch", "update-password", data);
};

export const forgotPassword = (email) => {
  return axiosAPI("post", "forgot-password", { email });
};

export const resetPassword = (data) => {
  return axiosAPI("post", "reset-password", data);
};

export const uploadUserProfileImage = (pic) => {
  return axiosAPI("post", "upload-profile-image", { pic });
};

export const deleteCompany = (data) => {
  return axiosAPI("delete", "company", data);
};
